import httpClient from "Api/httpClient";

const END_POINT = "/exchange_rates";

const getExchangeRates = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, useCache: true, params: body }); // use cache: true, retryTimes: 3, throttle: true
};

const getExchangeRate = (exchange_rate_id) => {
    if (!exchange_rate_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + exchange_rate_id;
    return httpClient.get(SINGLE_END_POINT);
};

const getApiLayer = () => {
    const API_LAYER_END_POINT = END_POINT + "/refresh_rates";
    return httpClient.get(API_LAYER_END_POINT, { retryTimes: 3, useCache: true }); // use cache: true, retryTimes: 3, throttle: true
};

const printExchangeRate = (exchange_rate_id) => {
    if (!exchange_rate_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?exchange_rate_id=" + exchange_rate_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createExchangeRates = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateExchangeRates = (payload, exchange_rate_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + exchange_rate_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteExchangeRates = (exchange_rate_id) => {
    const DELETE_END_POINT = END_POINT + "/" + exchange_rate_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getExchangeRates, getExchangeRate, printExchangeRate, createExchangeRates, updateExchangeRates, deleteExchangeRates, getApiLayer };
